import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../util/core/Fetch';
import { useUserCity } from '../../../../Common/hooks/useUserCity';
import { getUserSession } from '../../../../../../util/core/Session';

const useLocations = (cityId) => {
    const { data } = useUserCity();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isCityManager =
        profile === config.default_foreign_key.sdg_profiles.cityManager;

    const city = isCityManager ? data?.city_id : cityId;

    return useQuery({
        queryKey: ['assistential-centers', city],
        queryFn: async () => {
            if (!city) {
                return [];
            }

            return await Fetch.post(
                config.endpoints.backend +
                    'governanceroom/dashboard/unifiedregistry/centers',
                {
                    filters: {
                        cd_ibge: city
                    }
                }
            );
        },
        enabled: !!city
    });
};

export default useLocations;
